import { ThemeContext } from "contexts";
import React, { useContext, useState } from "react";

type SecondaryButtonProps = {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  text: string;
  fullWidth?: boolean;
  displayPoweredBy?: boolean;
};

const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  onClick,
  text,
  fullWidth = false,
  displayPoweredBy = true,
}) => {
  const theme = useContext(ThemeContext);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div style={styles.container}>
      <button
        onClick={onClick}
        style={{
          ...styles.button,
          width: fullWidth ? "100%" : "auto",
          filter: isHovered ? "brightness(80%)" : "brightness(100%)",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {text}
      </button>
      {displayPoweredBy && (
        <p style={styles.poweredByText}>
          Powered by{" "}
          <a
            href="https://clinicos.ai"
            target="_blank"
            rel="noopener noreferrer"
            style={{ ...styles.link, color: theme?.themeColor ?? "#00B7F4" }}
          >
            ClinicOS
          </a>
        </p>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    width: "100%",
  },
  button: {
    color: "#000",
    border: "1px solid #000",
    fontSize: "16px",
    fontWeight: 600,
    transition: "filter 0.3s ease",
    padding: "10px 20px",
    borderRadius: "80px",
    background: "#fff",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    cursor: "pointer",
  },
  poweredByText: {
    fontWeight: 400,
    fontSize: "12px",
    color: "#646B6C",
  },
  link: {
    textDecoration: "none",
  },
} as const;

export default SecondaryButton;
